<div 
    [ngClass]="{ 'is-selected': isSelected }"
    class="tacho-item"
>
    <div class="tacho-item__content">
        <div
            [ngClass]="{
                'is-loading': isLoading,
                'drive': currentStateTacho === 0 && !isNoDriver,
                'work': currentStateTacho === 1 && !isNoDriver,
                'parking': currentStateTacho === 2 && !isNoDriver,
                'no-driver': isNoDriver
            }"
            class="tacho-item__content__column left"
        >
            <ng-container *ngIf="!isLoading">
                <img class="drive-img" src="/assets/img/tacho/primary@2x.png" alt="">
                <img class="work-img" src="/assets/img/tacho/primary_3@2x.png" alt="">
                <img class="parking-img" src="/assets/img/tacho/primary_5@2x.png" alt="">
                <img class="no-driver-img" src="/assets/img/no-driver-icon.svg" alt="">
            </ng-container>

            <div *ngIf="isLoading" class="loader">
                <mat-spinner
                    [strokeWidth]="1"
                    [diameter]="18"
                ></mat-spinner>
            </div>

            <span>
                <ng-container *ngIf="isLoading">...</ng-container>
                <ng-container *ngIf="!isLoading && !isNoDriver">
                    <ng-container *ngIf="currentStateTacho === 0">
                        {{ activeSlotData?.DD ? ((activeSlotData.DD / 1) | hoursTimeFormat) : '' }}
                    </ng-container>
                    <ng-container *ngIf="currentStateTacho === 1">
                        {{ activeSlotData?.DW ? ((activeSlotData.DW / 1) | hoursTimeFormat) : '' }}
                    </ng-container>
                    <ng-container *ngIf="currentStateTacho === 2">
                        {{ activeSlotData?.DR ? ((activeSlotData.DR / 1) | hoursTimeFormat) : '' }}
                    </ng-container>
                    <ng-container *ngIf="currentStateTacho === 3">
                        {{ activeSlotData?.DRd ? ((activeSlotData.DRd / 1) | hoursTimeFormat) : '' }}
                    </ng-container>
                </ng-container>
            </span>
        </div>
        <div class="tacho-item__content__column right">
            <span class="driver-name">
                {{ isLoading ? ('data-is-loading' | translate) : '' }}
                <ng-container *ngIf="!isLoading">
                    {{ isNoDriver ? ('driver-unkown' | translate) : (driver?.FN + " " + driver?.LN) }}
                </ng-container>
            </span>
            <span class="car-data wrap-text">
                {{ vehicleValue.Nm }}
            </span>
            <tk-vehicle-location 
                class="vehicle-location tk-c-gray"
                [location]="vehicleValue.LL"
            ></tk-vehicle-location>
        </div>

        <div *ngIf="hasBlockerReadPermissionUser && (vehicleValue?.blockerParametrId || vehicleValue?.blockerParametrIdOut2) && isBlocked" class="is-blocked">
            <i class="pi pi-lock icon"></i>
        </div>
    </div>
</div>

